import { gql } from '@apollo/client';

import { TService } from 'types';

export interface IServicesRequest {
  input: {
    client_uuid?: string;
  };
}
export interface IServicesResponse {
  services: Array<TService>;
}
export const SERVICES = gql`
  query services($input: ServicesInput!) {
    services(input: $input) {
      id
      title
      cost
      wholesale_cost
      tax_percent
      use_global_discounts
      created_at
      vat
      tax_system
    }
  }
`;
